import {
  addDoc,
  deleteDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import {
  getVouchersCollectionRef,
  getVoucherRef,
} from "../../../firebase/collectionReferences";

// Get All Vouchers
export async function getAllVouchers() {
  const vouchersRef = getVouchersCollectionRef();
  const snapshot = await getDocs(vouchersRef);
  const vouchers = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return vouchers;
}

// Get Voucher by redemption_user_id
export async function getVoucherByRedemptionUserId(user_id) {
  const vouchersRef = getVouchersCollectionRef();
  const snapshot = await getDocs(
    query(vouchersRef, where("redemption_user_id", "==", user_id))
  );
  const vouchers = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return vouchers;
}

// Delete Voucher
export async function deleteVoucher(voucher_id) {
  const voucherRef = getVoucherRef(voucher_id);
  await deleteDoc(voucherRef);
}

// Add Voucher
export async function addVoucher(data) {
  const vouchersRef = getVouchersCollectionRef();
  const voucher = await addDoc(vouchersRef, {
    ...data,
    createdAt: serverTimestamp(),
  });
  return voucher.id;
}

// Update Voucher
export async function updateVoucher(data) {
  const voucherRef = getVoucherRef(data.id);
  await updateDoc(voucherRef, data);
  return data.id;
}
